// ----------------------------------------------------------------------
// <copyright file="Izenda.SettingsByRangeConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';
import SettingsByRangeItemFieldModel from 'logic/models/Izenda.SettingsByRangeItemFieldModel';

const THRESHOLD = {
  THRESHOLD_TYPES: {
    STATIC: {
      value: 'static',
      label: localizer.getText('COMMON_LABEL_STATIC')
    },
    DYNAMIC: {
      value: 'dynamic',
      label: localizer.getText('COMMON_LABEL_DYNAMIC')
    },
    DYNAMIC_SUBTOTAL: {
      value: 'dynamic_subtotal',
      label: localizer.getText('COMMON_LABEL_DYNAMIC_SUBTOTAL')
    }
  }
}

export default {
  THRESHOLD: THRESHOLD,
  VALUE_TYPES: {
    none: {
      get label() {
        return localizer.getText('SETTINGS_LABEL_NONE');
      }
    },
    value: {
      get label() {
        return localizer.getText('SETTINGS_LABEL_VALUE');
      },
      dataStructure: {
        name: '',
        key: '',
        get fields() {
          return [new SettingsByRangeItemFieldModel()];
        },
        text: '',
        canDelete: true,
        thresholdType: 'static'
      }
    },
    rangeValue: {
      get label() {
        return localizer.getText('SETTINGS_LABEL_VALUE_RANGE');
      },
      dataStructure: {
        name: '',
        from: '',
        to: '',
        text: '',
        canDelete: true
      }
    },
    rangePercent: {
      get label() {
        return localizer.getText('SETTINGS_LABEL_PERCENTAGE_RANGE');
      },
      dataStructure: {
        name: '',
        from: '',
        to: '',
        text: '',
        canDelete: true
      }
    },
    allValues: {
      get label() {
        return localizer.getText('SETTINGS_LABEL_ALL_VALUE');
      },
      dataStructure: {
        name: '',
        key: '',
        get fields() {
          return [new SettingsByRangeItemFieldModel()];
        },
        text: '',
        canDelete: false
      }
    }
  },
  BOOLEAN_OPTION: {
    options: [
      {
        value: 'true',
        get label() {
          return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_VALUE_LIST_TRUE');
        }
      },
      {
        value: 'false',
        get label() {
          return localizer.getText('FILTER_DETAIL_CONFIG_CONSTANTS_VALUE_LIST_FALSE');
        }
      }
    ],
    blankOption: true
  },
  CONSTRAINTS: {
    presence: {
      presence: true,
      get message() {
        return localizer.getText('ROLE_SETUP_CONSTANT_CONSTRAINTS_REQUIRE_VALUE');
      }
    }
  },
  MESSAGE: {
    M02: {
      get DUPLICATE_NAME() {
        return localizer.getText('SETTINGS_MESSAGE_NAME_HAS_BEEN_DEFINED');
      },
      get VALUE() {
        return localizer.getText('SETTINGS_MESSAGE_COLOR_HAS_BEEN_DEFINED');
      },
      get FIELD_VALUE() {
        return localizer.getText('SETTINGS_MESSAGE_NO_FIELD_SELECTED');
      },
      get FIELD_FUNCTION_IS_MISSING() {
        return localizer.getText('SETTINGS_MESSAGE_NO_FUNCTION_SELECTED');
      },
      get VALUE_EMPTY() {
        return localizer.getText('SETTINGS_MESSAGE_NO_VALUE_SELECTED');
      },
      get RANGE_VALUE() {
        return localizer.getText('SETTINGS_MESSAGE_RANGE_COLOR_HAS_BEEN_DEFINED');
      },
      get RANGE_PERCENT() {
        return localizer.getText('SETTINGS_MESSAGE_PERCENT_COLOR_HAS_BEEN_DEFINED');
      },
      get INVALID_RANGE() {
        return localizer.getText('SETTINGS_MESSAGE_INVALID_RANGE');
      }
    },
    M03: {
      get VALUE() {
        return localizer.getText('SETTINGS_MESSAGE_ALTERNATIVE_TEXT_HAS_BEEN_DEFINED');
      },
      get RANGE_VALUE() {
        return localizer.getText('SETTINGS_MESSAGE_RANGE_ALTERNATIVE_TEXT_HAS_BEEN_DEFINED');
      },
      get RANGE_PERCENT() {
        return localizer.getText('SETTINGS_MESSAGE_PERCENT_ALTERNATIVE_TEXT_HAS_BEEN_DEFINED');
      },
      get INVALID_RANGE() {
        return localizer.getText('SETTINGS_MESSAGE_INVALID_RANGE');
      }
    },
    M04: {
      get FIELD_VALUE_REQUIRED() {
        return localizer.getText('SETTINGS_MESSAGE_FIELD_IS_REQUIRED')
      }
    }
  },
  DATA_TYPE: {
    TEXT: 'Text',
    BOOLEAN: 'Boolean',
    NUMERIC: 'Numeric',
    DATETIME: 'Datetime',
    TIME: 'Time',
    MONEY: 'Money'
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.SettingsByRangeConstants.js